import {NullableKeys} from '@fl/cmsch-fe-library';
import {genNakedPropOrCrash, opt, optEmptyString} from 'ts-opt';

import {CreatePermission} from 'api/gen/CreatePermission';
import {UpdatePermission} from 'api/gen/UpdatePermission';
import {State} from 'app/setup';
import {formHelpers} from 'utils/forms';

import {createOrUpdatePermissionFormName, CreateOrUpdatePermissionFormValues} from '../types/permission-form-values';

/**
 * Builds the API payload for creating a permission.
 *
 * @param values Permission form values.
 * @returns API payload for creating a permission.
 */
export const buildPermissionCreateValuesForApi =
(values: NullableKeys<CreateOrUpdatePermissionFormValues>): CreatePermission => {
    const get = genNakedPropOrCrash(values);

    return {
        actionName: get('actionName'),
        code: get('code'),
        controllerName: get('controllerName'),
        comment: optEmptyString(values.comment).orNull(),
        discriminatorId: get('discriminatorId'),
        userEnable: opt(values.userEnable).orFalse(),
    };
};

/**
 * Builds the API payload for updating a permission.
 *
 * @param values Permission form values.
 * @returns API payload for updating a permission.
 */
export const buildPermissionUpdateValuesForApi =
    (values: NullableKeys<CreateOrUpdatePermissionFormValues>): UpdatePermission => ({
        code: opt(values.code).orCrash('missing code'),
        comment: optEmptyString(values.comment).orNull(),
        discriminatorId: opt(values.discriminatorId).orCrash('missing discriminator id'),
        userEnable: opt(values.userEnable).orFalse(),
    });

/**
 * Reads the permission form values from Redux state.
 *
 * @param state Redux state.
 * @returns Permission form values if present.
 */
export const getPermissionFormValues = (state: State): NullableKeys<CreateOrUpdatePermissionFormValues> =>
    formHelpers.formValues(createOrUpdatePermissionFormName)(state).orCrash('no permission form values');
